//@flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { PdfButton } from './pdf-button';
import { PrintButton } from './print-button';

export function VoucherButton(): Node {
  return (
    <Grid>
      <GridSlot name="savepdf" >
        <PdfButton />
      </GridSlot>
      <GridSlot name="printvoucher" >
        <PrintButton />
      </GridSlot>
    </Grid>
  );
}

const GridSlot = styled.div`
  grid-area: ${props => props.name};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "savepdf printvoucher";
  grid-column-gap: 1em;
`;
